// @flow

import { MediaQuery } from '@riseart/common';
import { Col, Row } from '@riseart/antd-provider';
import { FilterExpandable, FilterExpandableContent } from '@riseart/filter';
import {
  CLEAR_BUTTON_TYPE,
  CLEAR_LINK_TYPE,
  FILTER_ITEM_TYPE,
  FILTER_EXPANDABLE_FOOTER_TYPE,
} from 'shared_models/filters/preconfigTypes';

import {
  raScreenSmMax,
  raScreenMd,
  raScreenMdMax,
  raScreenLg,
} from '@riseart/antd-provider/dist/website/variables.less';
import { filterColCenterCls } from 'shared_models/filters/styles.less';

export const ArtistArtFilterModel = [
  {
    type: MediaQuery,
    props: { minWidth: 0 },
    items: [
      {
        type: MediaQuery,
        props: { maxWidth: raScreenSmMax },
        items: [
          {
            type: FilterExpandableContent,
            items: [
              {
                type: Row,
                props: { type: 'flex', justify: 'flex-start', gutter: 32 },
                items: [
                  {
                    type: Col,
                    props: { span: 24 },
                    items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'size' } }],
                  },
                  {
                    type: Col,
                    props: { span: 24 },
                    items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'price', marks: false } }],
                  },
                  {
                    type: Col,
                    props: { span: 24 },
                    items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'height', marks: false } }],
                  },
                  {
                    type: Col,
                    props: { span: 24 },
                    items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'width', marks: false } }],
                  },
                  {
                    type: Col,
                    props: { span: 24 },
                    items: [
                      {
                        ...FILTER_ITEM_TYPE,
                        props: { dimension: 'orientation' },
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        type: MediaQuery,
        props: { minWidth: raScreenMd, maxWidth: raScreenMdMax },
        items: [
          {
            type: Row,
            props: { type: 'flex', justify: 'space-between', gutter: 32 },
            items: [
              {
                type: Col,
                props: { span: 10 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'size' } }],
              },
              {
                type: Col,
                props: { span: 14 },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'price', marks: false } }],
              },
            ],
          },
          {
            type: FilterExpandable,
            props: { type: 'flex', justify: 'space-between', gutter: 32 },
            items: [
              {
                type: FilterExpandableContent,
                items: [
                  {
                    type: Row,
                    props: { type: 'flex', justify: 'flex-start', gutter: 32 },
                    items: [
                      {
                        type: Col,
                        props: { span: 10 },
                        items: [
                          { ...FILTER_ITEM_TYPE, props: { dimension: 'height', marks: false } },
                        ],
                      },
                      {
                        type: Col,
                        props: { span: 10 },
                        items: [
                          { ...FILTER_ITEM_TYPE, props: { dimension: 'width', marks: false } },
                        ],
                      },
                      {
                        type: Col,
                        props: { span: 4, className: filterColCenterCls },
                        items: [
                          {
                            ...FILTER_ITEM_TYPE,
                            props: { dimension: 'orientation', showLabel: false },
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                ...FILTER_EXPANDABLE_FOOTER_TYPE,
                items: [CLEAR_LINK_TYPE],
              },
            ],
          },
        ],
      },
      {
        type: MediaQuery,
        props: { minWidth: raScreenLg },
        items: [
          {
            type: Row,
            props: { type: 'flex', justify: 'space-between', gutter: 32 },
            items: [
              {
                type: Col,
                props: {
                  span: ({ totalActiveFilters = 0 }: Object) => (totalActiveFilters ? 3 : 5),
                },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'size' } }],
              },
              {
                type: Col,
                props: {
                  span: ({ totalActiveFilters = 0 }: Object) => (totalActiveFilters ? 5 : 5),
                },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'height', marks: false } }],
              },
              {
                type: Col,
                props: {
                  span: ({ totalActiveFilters = 0 }: Object) => (totalActiveFilters ? 5 : 5),
                },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'width', marks: false } }],
              },
              {
                type: Col,
                props: {
                  span: ({ totalActiveFilters = 0 }: Object) => (totalActiveFilters ? 5 : 6),
                },
                items: [{ ...FILTER_ITEM_TYPE, props: { dimension: 'price', marks: false } }],
              },
              {
                type: Col,
                props: { span: 3, className: filterColCenterCls },
                items: [
                  { ...FILTER_ITEM_TYPE, props: { dimension: 'orientation', showLabel: false } },
                ],
              },
              {
                type: Col,
                skipRenderer: ({ totalActiveFilters = 0 }: Object) => !totalActiveFilters,
                props: {
                  span: ({ totalActiveFilters = 0 }: Object) => (totalActiveFilters ? 3 : 0),
                },
                items: [CLEAR_BUTTON_TYPE],
              },
            ],
          },
        ],
      },
    ],
  },
];
